import { useEffect, useState } from "react";
import moment from "moment-timezone";
import { Row, Col, Grid } from "antd";

import { RADatePicker, RATimePicker } from "@/components/customs";
import { RAInputTimePickerMobile, RADepartureWindow } from "@/components/atoms";
import { SvgCalendar, SvgTime } from "@/assets/icons";
import dayjs from "dayjs";

const { useBreakpoint } = Grid;

export function InputDepartureWindow({ formValues = {}, onChange, error = {}, disabledFromDate, prevLegDate = null }) {
	const screens = useBreakpoint();

	const { departure_datetime, departure_window_datetime } = formValues;
	const [isTouchScreen, setIsTouchScreen] = useState(false);

	useEffect(() => {
		if ("ontouchstart" in window || navigator.msMaxTouchPoints > 0 || navigator.maxTouchPoints > 0) {
			setIsTouchScreen(true);
		}
	}, []);

	if (!screens.xs) {
		return (
			<RADepartureWindow
				fromDate={departure_datetime}
				toDate={departure_window_datetime}
				disabledFromDate={disabledFromDate}
				onChange={(fromDate, toDate) => {
					let departureFromDate = fromDate;
					if (!departure_datetime) {
						departureFromDate = moment(fromDate).set({ hour: 12, minute: 0 }).toISOString();
					}

					let departureToDate = toDate;
					if (!departure_window_datetime) {
						departureToDate = moment(toDate).set({ hour: 12, minute: 0 }).toISOString();
					}

					onChange({
						...formValues,
						departure_datetime: departureFromDate,
						departure_window_datetime: departureToDate,
					});
				}}
				error={error?.departure_window_datetime}
				defaultPickerValue={prevLegDate ? dayjs(prevLegDate, "YYYY-MM") : null}
			/>
		);
	}
	return (
		<Row gutter={[0, 20]}>
			<Col span={24}>
				<Row gutter={[8, 12]}>
					<Col span={12}>
						<RADatePicker
							prefix={<SvgCalendar color="#595959" />}
							placeholder="Start date"
							value={departure_datetime || null}
							disabledFromDate={disabledFromDate}
							format="ddd, MMM DD"
							onChange={(val) => {
								let value = val;
								if (!departure_datetime) {
									value = moment(val).set({ hour: 12, minute: 0 }).toISOString();
								}
								onChange({
									...formValues,
									departure_datetime: value,
								});
							}}
							error={error?.departure_datetime}
							defaultPickerValue={prevLegDate ? dayjs(prevLegDate, "YYYY-MM") : null}
						/>
					</Col>
					<Col span={12}>
						{isTouchScreen ? (
							<>
								<RAInputTimePickerMobile
									prefix={<SvgTime color="#595959" />}
									placeholder="Time"
									value={departure_datetime || null}
									disabled={!departure_datetime}
									onChange={(val) => {
										let date = departure_datetime ? moment(departure_datetime) : moment();
										let time = moment(val);
										date = moment(date).set({
											hour: time.get("hour"),
											minute: time.get("minute"),
										});
										onChange({
											...formValues,
											departure_datetime: date.toISOString(),
										});
									}}
								/>
							</>
						) : (
							<>
								<RATimePicker
									prefix={<SvgTime color="#595959" />}
									placeholder="Time"
									value={departure_datetime || null}
									dropdownAlign={{ offset: [-44, 4] }}
									onChange={(val) => {
										let date = departure_datetime ? moment(departure_datetime) : moment();
										let time = moment(val);
										date = moment(date).set({
											hour: time.get("hour"),
											minute: time.get("minute"),
										});
										onChange({
											...formValues,
											departure_datetime: date.toISOString(),
										});
									}}
								/>
							</>
						)}
					</Col>
				</Row>
			</Col>
			<Col span={24}>
				<Row gutter={[8, 12]}>
					<Col span={12}>
						<RADatePicker
							prefix={<SvgCalendar color="#595959" />}
							placeholder="End date"
							value={departure_window_datetime || null}
							disabled={!departure_datetime}
							disabledFromDate={departure_datetime || disabledFromDate}
							format="ddd, MMM DD"
							onChange={(val) => {
								let value = val;
								if (!departure_window_datetime) {
									value = moment(val).set({ hour: 12, minute: 0 }).toISOString();
								}
								onChange({
									...formValues,
									departure_window_datetime: value,
								});
							}}
							error={error?.departure_window_datetime}
							defaultPickerValue={departure_datetime ? dayjs(departure_datetime, "YYYY-MM") : null}
						/>
					</Col>
					<Col span={12}>
						<>
							{isTouchScreen ? (
								<>
									<RAInputTimePickerMobile
										prefix={<SvgTime color="#595959" />}
										placeholder="Time"
										value={departure_window_datetime || null}
										disabled={!departure_datetime}
										onChange={(val) => {
											let date = departure_window_datetime
												? moment(departure_window_datetime)
												: moment();
											let time = moment(val);
											date = moment(date).set({
												hour: time.get("hour"),
												minute: time.get("minute"),
											});
											onChange({
												...formValues,
												departure_window_datetime: date.toISOString(),
											});
										}}
									/>
								</>
							) : (
								<>
									<RATimePicker
										prefix={<SvgTime color="#595959" />}
										placeholder="Time"
										value={departure_window_datetime || null}
										disabled={!departure_datetime}
										dropdownAlign={{ offset: [-44, 4] }}
										onChange={(val) => {
											let date = departure_window_datetime
												? moment(departure_window_datetime)
												: moment();
											let time = moment(val);
											date = moment(date).set({
												hour: time.get("hour"),
												minute: time.get("minute"),
											});
											onChange({
												...formValues,
												departure_window_datetime: date.toISOString(),
											});
										}}
									/>
								</>
							)}
						</>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
